import * as zod from 'zod';
import { EPriority } from '@graphql/__generated__';

const dealsSchema = zod.record(
  zod.string(),
  zod.object({
    name: zod.string().max(250).optional().nullable(),
    priority: zod.union(Object.values(EPriority).map((c): zod.ZodTypeAny => zod.literal(c)) as any).optional(),
    startDate: zod.date().optional().nullable(),
    endDate: zod.date().optional().nullable(),
    salesforceId: zod.string().max(250).optional().nullable(),
    margin: zod.number().max(99.99).optional().nullable(),
    bidFloor: zod.number().optional().nullable(),
    dspIds: zod.array(zod.number()).optional(),
  })
);

export const bulkEditSchema = zod.object({
  removeAllOptimization: zod.boolean().default(false),
  replaceCurrentDsps: zod.boolean().default(false),
  deals: dealsSchema,
  optimization: zod.any(),
});
